export default {
  NEXT_ACTION_ID: 'nextActionId',
  CONNECTION_TYPE: 'connectionType',
  LIST_BRANCHES: 'listBranches',
  DEFAULT_CONNECTION: 'defaultConnection',
  CLASSIC_LIST_ID: 'classicListId',
  EDGE_TYPE: 'edgeType',
  DEFAULT_BRANCH_NAME: 'defaultBranchName',
  STATIC_BRANCHES: 'connections',
  AB_TEST_BRANCHES: 'connections',
  LOOP_BRANCH: 'loopBranch'
};